import { createAsyncThunk } from '@reduxjs/toolkit'
import { Dispatch } from 'react'

import { updateDataNode } from '@/endpoints'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'
import {
	openOrCloseDeleteModal,
	RootState,
	setNodeIdToRemove,
	setNodeToDelete,
} from '@/store'
import { loadNodeOrHistoryVersion } from '@/store/modules/node/utils'
import { logError } from '@/utils/errorHandling'
import { InitDataParams } from '@/utils/structureType/useStructureTypeActions'

export const deleteNodeThunk =
	(removedNodeId: number) =>
	(dispatch: Dispatch<any>, getState: () => RootState) => {
		const state = getState()
		const nodeToDelete = state.node.nodes[removedNodeId]

		if (!nodeToDelete) {
			throw new Error('Delete node thunk: node to delete not found')
		}
		dispatch(openOrCloseDeleteModal(true))
		dispatch(setNodeIdToRemove(removedNodeId))
		dispatch(setNodeToDelete(nodeToDelete))
	}
export const initDiagram = createAsyncThunk(
	'diagram/initDiagram',
	async ({
		nodeId,
		editMode = false,
		force = false,
		version,
		envId,
	}: InitDataParams) => {
		const node = await loadNodeOrHistoryVersion(nodeId, version, envId)
		return { node, editMode, force }
	},
)
export const saveDiagram = createAsyncThunk<
	StructureDto,
	StructureDto,
	{ rejectValue: string; state: RootState }
>(
	'diagram/saveDiagram',
	async (node: StructureDto, { getState, rejectWithValue }) => {
		try {
			const state = getState()

			const token = state.auth.token

			const diagram = state.diagram.diagrams[node.id]

			if (!diagram) {
				return rejectWithValue(
					new Error(`Saving unopened state ${JSON.stringify(node)}`),
				)
			}

			if (!token) return rejectWithValue(new Error('No token'))

			await updateDataNode(node.id, {
				data: JSON.stringify(diagram.form),
			})(token)

			return node
		} catch (error: unknown) {
			logError(error, { operation: 'diagram.saveDiagram' })
			const message =
				error instanceof Error ? error.message : 'Failed to save diagram'
			return rejectWithValue(message)
		}
	},
)
